import { NgClass, TitleCasePipe } from '@angular/common';
import { Component } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';
import { MatMenuModule } from '@angular/material/menu';
import { ButtonComponent } from '@examdojo/core/button';
import { IconComponent } from '@examdojo/core/icon';
import { QuestionItemTypeEnum } from '@examdojo/models/question';
import { CONTENT_ITEM_TYPE_TO_LONG_LABEL } from './question-item-editor.model';
import { QuestionItemsFormService } from './question-items-form.service';

@Component({
  selector: 'dojo-new-question-item-button',
  template: `
    <dojo-button [matMenuTriggerFor]="menu" [size]="'xs'">
      <div class="flex items-center gap-1.5">
        <dojo-icon [icon]="'add'" />
        <span>Add</span>
      </div>
    </dojo-button>

    <mat-menu #menu="matMenu" class="custom-mat-menu">
      @for (item of items; track item) {
        <div mat-menu-item (click)="createQuestionItem(item)" [ngClass]="ITEM_TYPE_COLOR_CLASS[item]">
          {{ CONTENT_ITEM_TYPE_TO_LONG_LABEL[item] | titlecase }}
        </div>
      }
    </mat-menu>
  `,
  standalone: true,
  imports: [MatIconModule, MatMenuModule, ButtonComponent, IconComponent, TitleCasePipe, NgClass],
})
export class NewQuestionItemButtonComponent {
  constructor(private readonly questionItemsFormService: QuestionItemsFormService) {}

  readonly ITEM_TYPE_COLOR_CLASS: Record<QuestionItemTypeEnum, string> = {
    [QuestionItemTypeEnum.Stimulus]: '!text-purple-500',
    [QuestionItemTypeEnum.StemGroup]: '!text-indigo-500',
    [QuestionItemTypeEnum.Stem]: '!text-sky-500',
    [QuestionItemTypeEnum.Options]: '!text-green-500',
  };

  readonly QuestionItemTypeEnum = QuestionItemTypeEnum;
  readonly items: QuestionItemTypeEnum[] = [
    QuestionItemTypeEnum.Stimulus,
    QuestionItemTypeEnum.StemGroup,
    QuestionItemTypeEnum.Stem,
    QuestionItemTypeEnum.Options,
  ];
  readonly CONTENT_ITEM_TYPE_TO_LONG_LABEL = CONTENT_ITEM_TYPE_TO_LONG_LABEL;

  createQuestionItem(type: QuestionItemTypeEnum) {
    this.questionItemsFormService.addItem(type);
  }
}
